import { render, staticRenderFns } from "./PloomesConfigCard.vue?vue&type=template&id=b6744cee&"
import script from "./PloomesConfigCard.vue?vue&type=script&lang=ts&"
export * from "./PloomesConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports